module.exports = __webpack_public_path__ + "officialStatic/img/tqj.287452a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/tqj.png
// module id = 87bm
// module chunks = 0